import React from 'react';
import { ArchieveData } from '../models/card';
import * as Utility from '../utils/Utility';

interface CardProps {
    theme?: string;
    className?: string;
    link?: string;
    archieve: ArchieveData;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const hashTageName = (archieve: ArchieveData) => {
    const newData = archieve.name.split('|');
    const isShowTwoline = newData.length > 0;
    let hashtag = null;
    if(archieve.isShow){
        if(isShowTwoline){
            hashtag =  (
                <React.Fragment>
                    <h4 style={{ fontSize: '35px', marginBottom: '0', lineHeight: '42px', width: '100%' }} className="title">{newData[0]}</h4>
                    <h4 style={{ fontSize: '35px', marginBottom: '0', lineHeight: '42px', width: '100%', marginTop: '0' }} className="title">{newData[1]}</h4>
                </React.Fragment>
            );
        } else {
            hashtag = (
                <React.Fragment>
                    <h4 style={{ fontSize: '35px', marginBottom: '0', lineHeight: '42px', width: '100%' }} className="title">{newData[0]}</h4>
                </React.Fragment>
            )
        }
    } else {
        hashtag = (
            <React.Fragment>
                <h4 style={{ fontSize: '35px', marginBottom: '0', lineHeight: '42px', width: '100%' }} className="title">#โทสะ</h4>
            </React.Fragment>
        )
    }
    return hashtag;
}

const genDescription = (archieve: ArchieveData) => {
    let description: any = archieve.description;
    if(!archieve.isShow){
        description = 'ผู้บรรยายหรือกองบรรณาธิการตกลงให้ปกปิดเนื้อหาเพื่อความปลอดภัยของผู้มีส่วนเกี่ยวข้อง';
    }
    return description;
}

const genCategory = (archieve: ArchieveData) => {
    let description: any = (<span> การเมือง(ปกปิดข้อมูล) </span>);
    if(archieve.isShow){
        description = archieve.categories?.map((category,index) => (
            <span key={index}> {category} </span>
        ))
    }
    return description;
}

const Card: React.FC<CardProps> = (props: CardProps) => {
    const { className, archieve } = props;
    const archeiveTweet = archieve?.noOfTweets ? archieve?.noOfTweets : 0;
    const noOfTweet = Utility.numberWithCommas(archeiveTweet);
    const angerClass = archieve.isShow ? '' : 'card-anger';
    let hashtag = hashTageName(archieve);
    let category = genCategory(archieve);
    let description = genDescription(archieve);
    return (
        <React.Fragment>
            <div className={`${className ? className : ''}`} onClick={props.onClick} style={{ fontSize: '24px', position: 'relative' }}>
                <div className={`card-archieve ${angerClass}`}>
                    <div>
                        <div className="sub-title" style={{ fontSize: '20px' }}>{archieve?.date ? archieve?.date : ''}</div>
                    </div>
                    { hashtag }
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '16px' }}>
                            { category }
                        </div>
                        <div>
                            <div className="text-right">
                                <h4>{noOfTweet}</h4>
                                <p style={{ marginBottom: '5px', fontSize: '16px' }}>Volume (Tweets)</p>
                            </div>
                        </div>
                    </div>
                    <hr style={{ margin: '5px 0px' }} />
                    <div style={{ wordBreak: 'break-all', height: '140px', overflow: 'hidden', fontWeight: 500 }}>
                        {description}
                    </div>
                    <div className="container-center" style={{ position: 'absolute', bottom: 0, left: '30%', right: '30%', fontSize: '16px' }}>
                        + เพิ่มคำบรรยาย
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Card;